import { useEffect, useState } from 'react';

import { Steps, message } from 'antd';

import BulkUploader from './BulkUploader';
import Downloader from './Downloader';
import CallApi from '../../API_Utils/APIUtil/CallApi';
import CustomHeader from '../../Components/Common/CustomHeader';
import AppLayout from '../../Components/Common/Layout';
import { getError } from '../../clientUtils';

const steps = [{ title: 'Fetch Details' }, { title: 'Upload SKU' }];

function BulkUpload() {
  const [step, setStep] = useState(0);
  const [sampleDownloadLink, setSampleDownloadLink] = useState(null);
  const [jobResponse, setJobResponse] = useState(null);
  useEffect(() => {
    // first
    CallApi(
      'sampleDownloadReorder',
      { report_name: 'Reorder Report' },
      undefined,
      undefined,
      (res) => setSampleDownloadLink(res.link),
      (res) => message.error(getError(res))
    );
  }, []);

  const header = {
    title: 'New Bulk Reorder Request',
    tag: null
  };
  const onNext = (jobResponse) => {
    setStep(1);
    setJobResponse(jobResponse);
  };
  const onPrevious = () => {
    setStep(0);
  };
  return (
    <AppLayout className="create" selected="bulkUploader">
      <>
        <CustomHeader tag={header?.tag} title={header?.title} />
        <section className="grey-bg-strip">
          <Steps current={step} items={steps} size="small" />
        </section>
        {step === 0 ? <Downloader onNext={onNext} jobResponse={jobResponse} /> : null}
        {step === 1 ? (
          <BulkUploader onPrevious={onPrevious} sampleDownloadLink={sampleDownloadLink} jobId={jobResponse.id} />
        ) : null}
      </>
    </AppLayout>
  );
}

export default BulkUpload;
